import globalUseStyles from '../../../../styles/globalCustomStyles';

import { Card, Typography } from '@mui/material';
import { useRecordContext, useTranslate } from 'react-admin';
import InfoTooltipIcon from "../../../../assets/InfoTooltipIcon";
import CustomTooltip from '../../../aegeon/CustomTooltip';
import ChartLoading from '../../../aegeon/charts/ChartLoading';
import ChartNoData from '../../../aegeon/charts/ChartNoData';
import { getObjectiveYear } from '../../../aegeon/compute_performances';
import { is_value_defined } from '../../../aegeon/helper';
import useQueryProvider from '../../../aegeon/query/useQueryProvider';

const SiteEnergeticPerformanceCRREM = (props) => {
  const globalClasses = globalUseStyles();
  const t = useTranslate();
  const { type, isGraph, data, isLoading, year, values, usage, colors } = props;
  const record = useRecordContext(props);
  const siteId = record?.id;

  let { data: crremObjectivesTable } = useQueryProvider(
    'sites',
    {
      query_name: "getCrremObjectivesTable",
      id: siteId,
      params: {
        type: usage
      },
    }
  );

  const getObjectiveText = (year, type) => {
    if (year === 0) {
      return t(`sites.energetic_performance.${type}.year_passed`);
    } else if (year === 1) {
      return t(`sites.energetic_performance.${type}.year_not_passed`);
    } else {
      return t(`sites.energetic_performance.${type}.year`) + year;
    }
  };

  const value = year ? data?.performances?.find((p) => p.type === type)?.values?.find((v) => v.year === year)?.value : data?.performances?.find((p) => p.type === type)?.value
  const unit = data?.performances?.find((p) => p.type === type)?.unit;

  const value_displayed = Math.round(value * 100) / 100 + " " + unit;

  const title = t('sites.energetic_performance.' + type + '.title');
  const subtitle = t('sites.energetic_performance.' + type + '.subtitle');
  const tooltip_text = t('sites.energetic_performance.' + type + '.tooltip_text');

  const objective_year = getObjectiveYear(type, data, crremObjectivesTable);

  return (
    <Card className={globalClasses.DetailCard}>
      <div className={globalClasses.energeticPerfsCrremTitles}>
        <div className={globalClasses.DetailCardTableTitle}>
          <Typography variant="h8">{title}</Typography>
          <CustomTooltip title={tooltip_text} icon={<InfoTooltipIcon />} />
        </div>
        <div className={globalClasses.DetailCardTableSubtitle}>
          {subtitle}
          <br />
          {t('sites.energetic_performance.general.choose_crrem_usage') + t("sites.energetic_performance.general.usages." + usage)}
        </div>
      </div>
      <div>
        {isLoading ? <ChartLoading /> :
          !is_value_defined(value) ? <ChartNoData /> :
            <div className={globalClasses.energeticPerfCards}>
              <Typography variant="h3" component="div" color={type == "CRREM_PCS" ? colors["energy"] : colors["ghg"]} className={globalClasses.compositionText}>
                {value_displayed}
              </Typography>
              <br />
              <Typography variant="h3" component="div" color={type == "CRREM_PCS" ? colors["energy"] : colors["ghg"]} className={globalClasses.compositionText}>
                {getObjectiveText(objective_year, type)}
              </Typography>
            </div>
        }
      </div>
    </Card>
  )
};

export default SiteEnergeticPerformanceCRREM; 